// ML001-F0252..F0255 (WebUI #170): the customer's own monthly statement page. Its own route, so the documented own-account outline
// (T-LED-NODEUI-012) is unchanged. The viewer is the customer: the user id comes from the session, never from the URL.
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Layout from './layout/Layout';
import { useAuth } from '../context/AuthContext';
import { organisationApi } from '../services/api';
import CustomerMonthlyDraft from './ledger/CustomerMonthlyDraft';
import AdviceStatementPanel from './ledger/AdviceStatementPanel';
import { isAdviceStatementPanelEnabled } from '../utils/txFeatureFlags';
import StatementsList from './ledger/StatementsList';
import StatementGenerateDialog from './ledger/StatementGenerateDialog';
import StatementView from './ledger/StatementView';
import { STATEMENT_DOCUMENTS_SERVED, STATEMENT_MANAGE_KEY } from './ledger/statementModel';
import './LedgerAccountPage.css';

export default function LedgerStatementPage() {
  const { orgId } = useParams();
  const { user } = useAuth();
  const [permissions, setPermissions] = useState(null);
  const [generating, setGenerating] = useState(false);
  const [listKey, setListKey] = useState(0);

  useEffect(() => {
    let current = true;
    organisationApi.getMyPermissions(orgId)
      .then((response) => { if (current) setPermissions(response?.data?.data?.permissions || response?.data?.permissions || {}); })
      .catch(() => { if (current) setPermissions({}); });
    return () => { current = false; };
  }, [orgId]);

  return (
    <Layout>
      <div className="ledger-account-page" data-testid="ledger-statement-page">
        <Link to={`/app/ledger/${orgId}/account`}>← My account</Link>
        {permissions && user?.id ? (
          <>
            <CustomerMonthlyDraft orgId={orgId} userId={user.id} permissions={permissions} />
            {isAdviceStatementPanelEnabled() ? <AdviceStatementPanel orgId={orgId} scope="customer" /> : null}
            <StatementView orgId={orgId} customerId={user.id} />
            {STATEMENT_DOCUMENTS_SERVED && permissions[STATEMENT_MANAGE_KEY] === true ? (
              <button type="button" onClick={() => setGenerating(true)}>Generate statement</button>
            ) : null}
            {STATEMENT_DOCUMENTS_SERVED ? <StatementsList orgId={orgId} customerId={user.id} reloadKey={listKey} /> : null}
            {STATEMENT_DOCUMENTS_SERVED && generating ? (
              <StatementGenerateDialog
                orgId={orgId}
                customerId={user.id}
                onClose={() => setGenerating(false)}
                onIssued={() => setListKey((k) => k + 1)}
              />
            ) : null}
          </>
        ) : <p role="status">Loading your statement…</p>}
      </div>
    </Layout>
  );
}
